(function(){
  'use strict';

  document.querySelectorAll('script[data-section-id]').forEach(initSection);

  function initSection(scriptEl){
    const sectionId = scriptEl.getAttribute('data-section-id');
    const root = document.getElementById('ls-root-' + sectionId);
    if (!root || root.dataset.ssInit) return;
    root.dataset.ssInit = '1';

    const dataEl = document.getElementById('ls-product-data-' + sectionId);

    // ---- real text measurement (not an estimate) — a generic average
    // character-width ratio badly underestimates short, wide-letter words
    // like "WOMEN" (heavy on W/M), so measure actual rendered width instead.
    const measureSvg = document.createElementNS('http://www.w3.org/2000/svg','svg');
    measureSvg.setAttribute('style','position:absolute;visibility:hidden;width:0;height:0;overflow:hidden;');
    const measureText = document.createElementNS('http://www.w3.org/2000/svg','text');
    measureSvg.appendChild(measureText);
    document.body.appendChild(measureSvg);
    function measureTextWidth(text, fontSize, family, weight){
      measureText.setAttribute('font-size', fontSize);
      measureText.setAttribute('font-family', family);
      measureText.setAttribute('font-weight', weight);
      measureText.textContent = text;
      return measureText.getComputedTextLength();
    }
    function fitFontSizeByMeasurement(text, maxWidth, maxFontSize, minFontSize, family, weight){
      if (measureTextWidth(text, maxFontSize, family, weight) <= maxWidth) return maxFontSize;
      let lo = minFontSize, hi = maxFontSize, best = minFontSize;
      for (let i=0;i<14;i++){
        const mid = (lo+hi)/2;
        if (measureTextWidth(text, mid, family, weight) <= maxWidth){ best = mid; lo = mid; } else { hi = mid; }
      }
      return best;
    }

    // Multi-line wrapping, built on the same real measurement as above rather
    // than a character-count estimate — a generic average badly underestimates
    // short, wide-letter words (that's the exact bug "WOMEN" hit on Restroom
    // Studio), so this measures actual rendered width at every step instead.
    function wrapTextMeasured(text, maxWidth, fontSize, family, weight){
      const words = String(text||'').split(/\s+/).filter(Boolean);
      if (!words.length) return [];
      const lines = [];
      let current = '';
      words.forEach(word=>{
        const test = current ? current+' '+word : word;
        if (current && measureTextWidth(test, fontSize, family, weight) > maxWidth){
          lines.push(current);
          current = word;
        } else {
          current = test;
        }
      });
      if (current) lines.push(current);
      return lines;
    }
    function fitWrappedTextMeasured(text, maxWidth, maxHeight, maxFontSize, minFontSize, family, weight, lineHeightMult){
      let fontSize = maxFontSize;
      let lines = wrapTextMeasured(text, maxWidth, fontSize, family, weight);
      while (fontSize > minFontSize){
        lines = wrapTextMeasured(text, maxWidth, fontSize, family, weight);
        const neededHeight = lines.length * fontSize * lineHeightMult;
        if (neededHeight <= maxHeight) break;
        fontSize -= 1;
      }
      lines = wrapTextMeasured(text, maxWidth, fontSize, family, weight);
      return { fontSize, lines };
    }

    let productData = { variants: [] };
    try { productData = JSON.parse(dataEl.textContent); } catch(e){ /* leave empty */ }

    // uploaded icon images (e.g. from Canva) — same load-check + fallback
    // pattern as the material photos: if a key is missing or the file 404s,
    // that icon just falls back to the drawn version in iconPath() below.
    const iconImagesEl = document.getElementById('ls-icon-images-' + sectionId);
    let iconImages = {};
    let iconImagesReady = Promise.resolve();
    if (iconImagesEl){
      try {
        const raw = JSON.parse(iconImagesEl.textContent);
        const checks = Object.keys(raw).map(key=>{
          return new Promise(resolve=>{
            const img = new Image();
            const done = (ok)=>{ if (ok) iconImages[key] = raw[key]; resolve(); };
            img.onload = ()=>done(true);
            img.onerror = ()=>done(false);
            img.src = raw[key];
            setTimeout(()=>done(false), 4000);
          });
        });
        iconImagesReady = Promise.all(checks);
      } catch(e){ /* falls back to drawn icons */ }
    }

    // ---- config (Common Room signs — Fitness Center, Pool, Business Center, etc.) ----
    const SHAPES = {
      rectangle: { label:'Rectangle' },
      arch:      { label:'Arch' },
      wavy:      { label:'Wavy' },
      bowed:     { label:'Bowed Edge' },
      diagonal:  { label:'Diagonal Cut' }
    };
    // Decorative treatments layered on top of whatever Shape is selected — modeled
    // after design capabilities (side stripes, offset shadows, two-tone splits,
    // banner graphics) rather than any one franchise's specific sign, and with no
    // logos — these are meant for independent hotels ordering their own design.
    const ACCENTS = {
      none:   { label:'None', needsColor:false },
      stripe: { label:'Side Stripe',        needsColor:true, incompatibleShapes:['circle','oval'] },
      bands:  { label:'Top & Bottom Bands', needsColor:true, incompatibleShapes:['circle','oval'] },
      shadow: { label:'Offset Shadow',      needsColor:true },
      split:  { label:'Two-Tone Split',     needsColor:true },
      banner: { label:'Banner Swoosh',      needsColor:true }
    };
    const ACCENT_COLORS = {
      charcoal: { label:'Charcoal', hex:'#2B2E33' },
      red:      { label:'Red',      hex:'#8C2F2A' },
      brass:    { label:'Brass',    hex:'#C6A05F' },
      sage:     { label:'Sage',     hex:'#6B7A5E' },
      custom:   { label:'Custom',   hex:null }
    };
    const MATERIALS = {
      standard:  { label:'1/8" Acrylic/Rowmark',              engrave:'#241D0F' },
      backplate: { label:'1/8" Acrylic/Rowmark + Backplate',  engrave:'#241D0F' }
    };
    const TYPEFACES = {
      serif: { label:'Classic Serif', family:"Georgia, 'Times New Roman', serif", weight:600 },
      sans:  { label:'Modern Sans',   family:"-apple-system, Helvetica, Arial, sans-serif", weight:700 },
      script:{ label:'Script',        family:"'Snell Roundhand', 'Brush Script MT', 'Segoe Script', cursive", weight:400, italic:false }
    };
    const SIZES = {
      small:  { label:'Small (8"×8")',  w:8,  h:8 },
      medium: { label:'Medium (10"×10")', w:10, h:10 },
      large:  { label:'Large (12"×10")', w:12, h:10 },
      tall:   { label:'Tall (8"×12")',  w:8,  h:12 },
      strip:  { label:'Strip (10"×4")', w:10, h:4 }
    };
    const MOUNTINGS = {
      flush:    { label:'Flush Wall-Mount' },
      standoff: { label:'Standoff Mount' }
    };
    const TEMPLATES = {
      exitStairs: {
        label: 'Exit Stairs',
        icon: 'stairs',
        headline: 'STAIRS AND EXIT',
        detail: '',
        layout: 'standard',
        defaultSize: 'medium'
      },
      areaOfRefuge: {
        label: 'Area of Refuge',
        icon: 'access',
        headline: 'AREA OF RESCUE ASSISTANCE',
        detail: '',
        layout: 'standard',
        defaultSize: 'medium'
      },
      fireElevator: {
        label: 'Fire: Do Not Use Elevator',
        icon: 'fireExit',
        headline: 'IN FIRE EMERGENCY DO NOT USE ELEVATOR',
        detail: 'USE EXIT STAIRS',
        layout: 'standard',
        defaultSize: 'medium'
      },
      stairId: {
        label: 'Stair ID (Floor Level)',
        icon: null,
        headline: 'STAIR A',
        detail: 'NO ROOF ACCESS',
        floorNumber: '4',
        footerText: '1 THROUGH 4  \u2193 DOWN TO LEVEL 1 FOR EXIT DISCHARGE',
        layout: 'stairId',
        defaultSize: 'tall'
      },
      floorLevel: {
        label: 'Floor Level Marker',
        icon: 'star',
        headline: 'LEVEL 1',
        detail: '',
        layout: 'floorLevel',
        defaultSize: 'strip'
      }
    };


    let state = {
      template:'exitStairs',
      headline:'STAIRS AND EXIT', headlineManual:false,
      detail:'', detailManual:false,
      floorNumber:'4', floorNumberManual:false,
      footerText:'1 THROUGH 4  \u2193 DOWN TO LEVEL 1 FOR EXIT DISCHARGE', footerTextManual:false,
      shape:'rectangle', material:'standard', typeface:'sans',
      size:'medium', mounting:'flush',
      plateColor:'#2B2E33', textColor:'#F2ECDE', textColorManual:true,
      accent:'none', accentColor:'charcoal', accentCustomColor:'#8C2F2A'
    };

    // Whichever room's text/sub-label/icons should currently render in the
    // live preview — the single-sign fields in single mode, or the room
    // that's focused/selected in the bulk rooms table.
    // ---- variant lookup: Option1=Size, Option2=Material, Option3=Mounting ----
    const variantMap = {};
    productData.variants.forEach(v=>{
      variantMap[v.size + '|' + v.material + '|' + v.mounting] = v;
    });

    function findVariant(){
      const key = SIZES[state.size].label + '|' + MATERIALS[state.material].label + '|' + MOUNTINGS[state.mounting].label;
      return variantMap[key] || null;
    }

    function escapeXml(s){ return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }

    function iconPath(id, color){
      const stroke = `stroke="${color}" stroke-width="2.4" fill="none" stroke-linecap="round" stroke-linejoin="round"`;
      switch(id){
        case 'access': return `<g transform="translate(1.294,0.000) scale(0.028125)"><g transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)" fill="${color}"><path d="M4120 12795 c-8 -2 -49 -9 -90 -15 -83 -14 -275 -77 -354 -117 -350
-176 -577 -531 -611 -953 -19 -243 66 -534 209 -713 l54 -68 6 -517 c3 -284 8
-881 11 -1327 9 -1324 24 -2926 31 -3285 l6 -335 192 2 c105 1 454 7 776 13
1641 31 2689 29 3083 -4 97 -9 188 -18 200 -21 28 -7 -37 123 614 -1230 985
-2043 1402 -2897 1447 -2957 11 -15 25 -12 167 41 230 86 429 169 894 371 696
303 1053 450 1091 450 22 0 29 46 28 185 -3 270 -51 496 -133 624 -57 88 -117
110 -231 87 -70 -15 -135 -42 -526 -215 -276 -122 -545 -208 -712 -227 l-58
-6 -133 273 c-231 472 -430 886 -851 1769 -224 470 -507 1063 -630 1318 l-223
462 -1954 0 -1953 0 -10 24 c-38 100 -59 365 -41 511 12 103 43 229 71 293
l19 42 1440 0 1441 0 0 510 0 510 -37 2 c-21 1 -596 2 -1278 3 -984 1 -1279 5
-1427 16 -103 8 -189 17 -192 20 -21 21 -33 1083 -20 1769 l6 325 77 75 c47
47 158 133 291 225 331 230 464 373 525 569 30 92 51 343 40 466 -47 514 -495
960 -1035 1030 -70 9 -186 11 -220 5z"/><path d="M2283 8130 c-627 -344 -1159 -826 -1552 -1405 -389 -574 -629 -1216
-690 -1850 -6 -60 -16 -171 -23 -245 -18 -193 -15 -601 6 -780 126 -1064 639
-2016 1471 -2731 691 -594 1537 -936 2692 -1088 619 -82 1339 18 1993 276 450
178 873 430 1270 755 144 118 451 421 560 553 41 50 112 126 156 170 126 124
174 238 175 416 2 289 -163 654 -411 913 l-96 99 -59 -94 c-444 -708 -1005
-1271 -1625 -1632 -350 -203 -780 -358 -1190 -428 -159 -27 -558 -38 -737 -19
-664 67 -1305 344 -1838 792 -110 92 -330 314 -420 423 -300 364 -535 823
-650 1271 -206 797 -96 1673 299 2377 190 340 460 654 726 847 210 151 254
216 249 368 -5 149 -4 239 5 497 9 278 -1 382 -50 478 -22 45 -83 127 -94 127
-3 0 -78 -41 -167 -90z"/></g></g>`;
        case 'stairs': return `<path d="M2 34 L2 29 L9 29 L9 24 L16 24 L16 19 L23 19 L23 14 L30 14 L30 8 L34 8 L34 34 Z" fill="${color}"/>`;
        case 'star': return `<path d="M18 2 L22.35 12.86 L34 13.76 L25.06 21.44 L27.9 32.74 L18 26.6 L8.1 32.74 L10.94 21.44 L2 13.76 L13.65 12.86 Z" fill="${color}"/>`;
        case 'fireExit': return `<g transform="translate(-3.078,-2.2645) scale(0.0317957)" fill="${color}"><path d="M455.602 266.816 457 268v2l3.813.813c3.307.813 4.928 1.589 7.187 4.187l1.688.375c3.176.858 5.721 2.412 8.562 4.063l3.266 1.87L484 283v2l2.688.875c2.816.956 5.563 1.993 8.312 3.125v2l7 2v2l1.715.332 2.223.48 2.214.458L510 297l1 3c1.698 1.319 1.698 1.319 3.824 2.445l2.37 1.325 2.494 1.355 2.435 1.379c4.335 2.389 7.892 3.949 12.877 4.496 2.875 1.438 2.875 1.438 5 3v2c4.428 2.745 7.719 4.485 13 5l1 3c2.315 1.614 2.315 1.614 5.23 3.117l3.341 1.82 1.787.957c3.098 1.661 6.18 3.354 9.263 5.043l1.893 1.035c5.814 3.186 11.539 6.513 17.236 9.903l2.752 1.637a3186 3186 0 0 1 9.458 5.663q3.48 2.087 6.958 4.18c3.996 2.404 8.005 4.785 12.02 7.157 13.137 7.762 26.232 15.584 39.246 23.552a813 813 0 0 0 17.203 10.248l3.33 1.926a72 72 0 0 0 7.134 3.367C694 405 694 405 695 407l2 1c3.53 2.28 5.415 4.822 7.625 8.375l1.79 2.836c1.45 2.551 2.575 5.038 3.585 7.789h2c2.504 8.844 1.212 18.11-3.172 26.148-2.359 3.568-3.8 4.892-7.828 5.852-2.11 1.323-2.11 1.323-4.125 2.938l-2.07 1.59c-1.896 1.496-1.896 1.496-3.805 3.472-3.35 3.35-6.913 3.156-11.5 3.188l-2.844.042c-4.027-.349-6.326-2.01-9.656-4.23a323 323 0 0 0-4.562-2.531l-2.665-1.457L657 460.5q-2.72-1.482-5.437-2.969l-2.434-1.326c-1.755-.993-3.452-2.087-5.129-3.205h-3v-2a432 432 0 0 0-4.375-2.562l-2.46-1.442L632 446l-2 1-1-2h-3v-2l-1.687-.75C622 441 622 441 619.75 439.125c-3.381-2.613-6.902-4.299-10.75-6.125a870 870 0 0 1-6.25-3l-3.016-1.437C597 427 597 427 594.988 424.91c-2.442-2.346-4.267-2.762-7.55-3.473-3.974-.867-5.628-1.613-8.438-4.437-8.063-5.4-16.825-9.82-25.335-14.468C537.318 393.59 537.318 393.59 533 390v-2l-2.54-.277c-3.977-.831-7.273-2.408-10.835-4.286l-1.941-.998A689 689 0 0 1 513 380v-2l-2.187-.75c-3.072-1.365-5.223-3.125-7.813-5.25-2.306-1.34-4.458-2.153-7-3-2.504-.835-4.668-1.794-7-3 2.057 9.136 4.175 18.116 7.266 26.973.737 3.04.68 5.656.608 8.763.255 4.576 1.791 8.905 3.126 13.264l.867 2.926A913 913 0 0 0 503 425h2c10.407 35.892 20.77 71.78 30.26 107.927 2.485 9.46 5.086 18.876 7.866 28.254a2308 2308 0 0 1 18.999 68.256l.82 3.094c1.248 4.83 2.235 9.562 2.922 14.504.814 5.215 2.536 9.316 4.84 14.03 2.471 5.609 3.798 11.57 5.293 17.497q.967 3.753 1.938 7.504l.495 1.927c2.073 8.034 4.324 16.019 6.567 24.007l3.214 11.454c6.585 23.47 13 46.983 19.354 70.516l1.963 7.268.938 3.479c1.859 6.87 3.776 13.716 5.84 20.529 1.304 5.2 1.606 10.411 1.691 15.754l.11 2.25c-.196 8.59-5.708 18.661-11.122 25.168-2.11 1.68-3.4 2.023-5.988 2.582-2.11 1.323-2.11 1.323-4.125 2.938l-2.07 1.59c-2.609 2.128-3.717 3.21-4.805 6.472-6.152.098-6.152.098-8 0l-1-1c-3.205-.073-6.4.004-9.605.063C568 881 568 881 564.762 880.438c-2.84-.668-2.84-.668-5.762.562-3.625-1.187-3.625-1.187-7-3q-.506-1.999-1-4c-1.63-1.85-1.63-1.85-3.687-3.5-1.076-.91-1.076-.91-2.172-1.84-1.815-1.407-3.598-2.574-5.578-3.722C537 863 537 863 536.25 859.875L536 857l-2-2c-1.73-2.594-2.486-4.169-3.34-7.066l-.766-2.597-.832-2.9-.894-3.088c-4.328-15.165-8.224-30.45-12.185-45.715a7794 7794 0 0 0-4.655-17.86l-.593-2.275c-1.369-5.213-2.843-10.39-4.36-15.562-3.148-10.84-5.97-21.764-8.812-32.687-4.44-17.064-4.44-17.064-9.125-34.062a2593 2593 0 0 1-8.375-30.313l-.644-2.375a2050 2050 0 0 1-6.767-25.586l-.558-2.175a2646 2646 0 0 1-2.582-10.157l-.918-3.613-.791-3.143c-.752-2.839-.752-2.839-1.895-5.523-1.019-2.584-1.065-4.55-.908-7.303l-2-1c-.633-2.363-.633-2.363-1.125-5.312l-.508-2.926C461 589 461 589 461 585h-3l-.75 1.875c-1.487 2.529-2.687 2.843-5.25 4.125a469 469 0 0 0-2 4 141 141 0 0 1-3.875 5.125l-2.055 2.633C442 605 442 605 439.867 606.055c-2.441 1.236-2.788 2.473-3.867 4.945a104 104 0 0 1-2.875 4.063l-1.492 2.035c-2.22 2.586-4.591 4.381-7.633 5.902q-.505 2-1 4c-1.107 1.616-1.107 1.616-2.469 3.164l-1.48 1.711-1.551 1.75c-3.622 3.927-3.622 3.927-6.5 8.375h-2l-1 3-2.437 1.938c-3.042 2.448-4.293 4.277-4.875 8.125-1.277 3.598-5.143 4.658-8.375 6.312-2.823 1.983-3.238 3.399-4.313 6.625a157 157 0 0 1-3 5l2.25 2.25L390 678l2.25 2.188C394 682 394 682 395 684l2.2.395c5.612 1.213 10.171 5.34 14.8 8.605l2.523 1.758c5.342 3.837 5.342 3.837 6.477 7.242 2.295 1.135 2.295 1.135 5 2 4.778 1.667 4.778 1.667 7 5l3 1 1 3c2.343 1.12 2.343 1.12 5 2 2.25.938 2.25.938 4 2l1 3c1.91 1.646 1.91 1.646 4.25 3.125l2.328 1.57c2.352 1.42 2.352 1.42 4.961 1.813 4.256.851 7.3 3.622 10.461 6.492a98 98 0 0 1 3 5l1.879.777c3.03 1.747 3.811 3.914 5.308 7.035l1.543 3.145c1.898 4.548 2.398 8.454 2.332 13.356l-.027 2.675L483 767h-2l.035 1.828c.01.8.018 1.599.027 2.422l.036 2.39c-.094 2.267-.466 4.189-1.098 6.36h-2v2h-2l-.746 1.75c-4.372 7.845-12.818 12.206-21.074 14.828-10.802 2.09-21.43.64-30.762-5.191-2.516-1.743-4.967-3.555-7.418-5.387a387 387 0 0 0-5-3.437l-2.187-1.497c-1.75-1.235-1.75-1.235-3.813-1.066v-3c-2.652-1.075-5.284-2.095-8-3v-2h-2l-.687-2.437L393 769c-1.662-.358-3.33-.688-5-1-3.045-1.662-5.807-3.73-8.625-5.75l-2.312-1.594c-4.065-2.88-6.705-5.182-9.063-9.656-3.069-2.902-6.307-5.661-10.5-6.5-4.164-.833-7.439-3.625-10.5-6.5l-1-3-2.312-.312c-4.177-1.069-5.341-3.168-7.688-6.688l-2.375-.437c-4.416-.947-6.208-3.937-8.625-7.563l-2.375-.437c-3.363-.721-4.359-2.014-6.625-4.563-3.821-4.219-3.821-4.219-9-6-3.39-2.26-3.955-3.535-5.562-7.187l-1.254-2.793c-4.163-10.62-5.338-22.714-1.122-33.52 2.635-5.432 6.036-9.926 9.938-14.5q1.976-2.463 3.938-4.937l2.011-2.497a378 378 0 0 0 4.196-5.351l2.105-2.715 1.89-2.469c1.882-2.055 3.37-2.875 5.86-4.031a41 41 0 0 0 3.938-7.187c1.34-2.288 2.73-2.647 5.062-3.813 1.183-1.866 1.183-1.866 2-4 .938-2.187.938-2.187 2-4l3-1 .438-1.937L346 605l1.824-.875c2.638-1.364 3.759-2.824 5.551-5.187l2.105-2.715 1.193-1.539c2.613-3.317 5.322-6.556 8.014-9.809l5.465-6.632L372 576l1.855-2.251q2.671-3.245 5.332-6.499l1.638-1.985c3.405-4.17 6.452-8.097 8.175-13.265l1.77-.852c3.097-1.594 4.732-3.828 6.918-6.523l2.386-2.898c1.732-2.453 2.45-3.841 2.926-6.727l1-2h2l.813-1.875C408 529 408 529 411 527a118 118 0 0 0 2-4c6.814-9.576 6.814-9.576 11.438-12.375 2.731-1.338 2.731-1.338 3.187-3.75L428 505c2.023-1.117 2.023-1.117 4-2 .575-8.057-1.353-15.181-3.431-22.878-8.152-30.404-8.152-30.404-7.569-40.122h-2l-4-18h-2l-.837 1.774c-1.112 2.128-2.323 3.926-3.772 5.835l-1.54 2.04-1.601 2.101-1.555 2.055a1254 1254 0 0 1-3.115 4.1 258 258 0 0 0-3.238 4.394l-1.608 2.217-1.446 2.024L393 450h-2l-1 3-2 1a938 938 0 0 0-2 4 158 158 0 0 1-4 5.188l-2.125 2.667C378 468 378 468 376 469a87 87 0 0 0-2 4c-1.31 2.347-2.657 4.672-4 7h-2l-.75 1.813c-1.426 2.495-2.974 3.48-5.25 5.187a179 179 0 0 0-2 4l-3 2-.875 2.375c-1.406 3.28-3.336 4.464-6.125 6.625a141 141 0 0 0-2 4 73 73 0 0 1-2.574 3.355l-1.514 1.874-1.6 1.959-3.261 4.027-1.592 1.964c-2.386 2.978-4.68 6.025-6.959 9.087-1.5 1.734-1.5 1.734-3.637 3.332-2.038 1.272-2.038 1.272-2.675 3.59C321.79 540.865 317.55 545.387 312 548a83 83 0 0 0-3 4c-4.515 5.321-9.656 7.004-16.375 7.813-5.255.377-9.567-.404-14.625-1.813v-2l-3.5-.5c-6.89-1.79-10.783-6.633-14.336-12.566-4.408-8.765-5.452-15.409-3.101-24.871 3.436-10.168 10.462-18.093 17.37-26.07 3.042-3.547 5.82-7.22 8.567-10.993 5.034-6.784 10.13-13.492 15.469-20.04 1.575-1.883 1.575-1.883 2.531-3.96h2l1-4h2l.25-1.75c.971-2.913 2.566-4.074 4.75-6.25 1.849-2.205 3.611-4.476 5.375-6.75l1.464-1.875A682 682 0 0 0 328 423l2 1c1.99-2.575 3.965-5.162 5.938-7.75l1.708-2.21 1.631-2.15 1.508-1.967c1.333-1.855 1.333-1.855 1.635-4.041.58-1.882.58-1.882 2.442-2.88L347 402c1.692-1.834 1.692-1.834 3.207-4.035l1.78-2.455 1.825-2.572a4113 4113 0 0 1 3.583-4.973l1.783-2.485c2.395-3.26 4.907-6.42 7.446-9.568 1.56-1.967 1.56-1.967 2.376-4.912a291 291 0 0 1 3.498-3.434c3.092-3.223 5.631-6.897 8.252-10.503l1.785-2.381c4.308-5.764 4.308-5.764 5.465-12.682-.836-3.334-2.002-6.488-3.25-9.687-.313-.855-.626-1.709-.95-2.588-1.51-3.991-2.663-6.776-5.8-9.725-1.517-3.79-1.184-7.975-1.187-12l-.038-2.156c-.01-3.807.17-6.595 2.225-9.844v-1c.506-3.845 1.252-5.362 4-8a206 206 0 0 0 2-5c2.212-4.692 4.067-7.834 9-10l2.688-.437c2.495-.325 2.495-.325 3.625-2.625L401 267h2v-2q3.996-1.23 8-2.437l2.254-.698c14.7-4.41 29.228-3.372 42.348 4.951M422 261v1h13v-1zm-44 43v9h1v-9zm1 10 1 4Zm106 49 1 2Zm1 2 1 4Zm1 4 1 3Zm1 4 1 3Zm1 3 1 3Zm1 4 1 3Zm1 3 1 3Zm1 4 1 3Zm1 3 1 3Zm1 4 1 3Zm1 3 1 3Zm-79 24 1 3Zm88 8 1 4Zm207 3v8h1v-8zm-206 1 1 2Zm1 3 1 3Zm1 3 1 4Zm203 1 1 4Zm-202 3 1 4Zm-86 1 1 3Zm287 0 1 3Zm-200 3 1 3Zm199 1 1 2Zm-285 1 1 3Zm87 1 1 3Zm197 0 1 2Zm-283 3 1 3Zm87 0 1 2Zm1 4 1 2Zm-87 1 1 2Zm88 3 1 3Zm1 3 1 2Zm-87 2 1 2Zm88 2 1 3Zm161 0v1c6.313.376 6.313.376 12-2-4.093-.124-7.959.366-12 1m-248 2 1 2Zm1 4 1 3Zm1 4 1 3Zm88 1 1 3Zm-87 3 1 3Zm1 4 1 2Zm88 0 1 3Zm1 3 1 2Zm-88 1 1 3Zm89 3 1 3Zm-88 1 1 3Zm90 6 1 3Zm2 7 1 3Zm2 8 1 2Zm-269 2 1 2Zm270 1 1 3Zm-271 2v13h1v-13zm272 2 1 3Zm1 3 1 3Zm1 4 1 3Zm1 4 1 3Zm-274 2 1 2Zm275 2 1 3Zm1 3 1 3Zm2 7 1 3Zm1 4 1 2Zm1 3 1 3Zm-257 3v1h14v-1zm258 1 1 3Zm1 4 1 2Zm1 3 1 2Zm1 3 1 3Zm1 4 1 3Zm1 4 1 3Zm1 3 1 3Zm1 4 1 3Zm1 4 1 3Zm-85 1 1 3Zm86 2 1 3Zm-85 3 1 2Zm86 1 1 3Zm1 3 1 3Zm-85 3 1 3Zm86 1 1 3Zm-85 3 1 2Zm86 1 1 2Zm-85 2 1 3Zm86 2 1 2Zm-85 2 1 2Zm86 1 1 3Zm-85 2 1 3Zm86 1 1 3Zm-85 3 1 3Zm86 1 1 3Zm-85 3 1 3Zm86 1 1 3Zm-85 3 1 3Zm86 0 1 4Zm-85 3 1 3Zm86 1 1 4Zm-85 3 1 3Zm86 1 1 3Zm-85 3 1 3Zm86 1 1 3Zm-85 3 1 3Zm86 1v8h1v-8zm-85 3 1 2Zm1 4 1 2Zm1 3 1 3Zm1 4 1 3Zm1 4 1 3Zm1 4 1 2Zm86 0 1 2Zm-85 3 1 3Zm86 0 1 2Zm-271 3 1 3Zm186 0 1 3Zm-187 4v14h1v-14zm188 0 1 3Zm86 0 1 2Zm1 3 1 3Zm-86 1 1 3Zm1 4 1 3Zm1 4 1 3Zm87 2 1 2Zm-277 1 1 4Zm191 1 1 2Zm1 3 1 3Zm-191 1 1 2Zm278 1 1 2Zm-86 2 1 2Zm1 3 1 3Zm87 3 1 2Zm-85 5 1 2Zm87 2 1 2Zm2 7 1 2Zm-86 2 1 3Zm1 4 1 2Zm87 1 1 2Zm-86 2 1 3Zm1 4 1 3Zm1 4 1 2Zm87 1 1 2Zm-86 3 1 2Zm87 0 1 2Zm-86 3 1 3Zm87 1 1 2Zm-86 4 1 2Zm-26 4 1 2Zm1 3v5h1v-5zm116 7 1 2Zm-86 4 1 2Zm87 0 1 2Zm-86 4 1 2Zm87 0 1 2Zm1 3 1 2Zm-120 1 1 2Zm34 2 1 4Zm87 1 1 2Zm-86 3 1 4Zm87 0 1 3Zm-86 4 1 3Zm87 0 1 2Zm-86 4 1 3Zm87 0 1 2Zm1 3 1 3Zm-86 4 1 3Zm87 0 1 2Zm-153 3 4 1Zm-14 1v1h13v-1zm168 0 1 2Zm-86 3 1 3Zm87 1 1 2Zm1 3 1 2Zm-87 1 1 2Zm1 2 1 4Zm87 1 1 2Zm-86 3 1 4Zm87 1 1 2Zm-86 3 1 4Zm87 0 1 2Zm-86 4 1 3Zm87 0 1 2Zm-86 3 1 4Zm87 0 1 3Zm-86 4 1 4Zm87 0 1 2Zm-86 4 1 4Zm87 0v5h1v-5zm-86 4 1 4Zm1 4 1 3Zm1 4 1 3Zm84 0v5h1v-5zm-83 3 1 4Zm82 3 1 2Zm-81 1 1 3Zm79 5 1 2Z"/><path d="M882 587h187l1 5-2 2v2h-2v2c-1.68 1.727-1.68 1.727-3.875 3.625l-2.18 1.914C1058 605 1058 605 1056 605l-.687 1.75c-1.661 2.847-3.628 4.37-6.313 6.25h-2l-1 3c-1.574 1.402-1.574 1.402-3.687 2.938-3.059 2.286-6.012 4.638-8.883 7.152l-1.873 1.639a563 563 0 0 0-3.683 3.27c-2.967 2.603-5.097 4.071-8.874 5.001a178 178 0 0 0-2 4c-3.656 3.324-7.822 5.846-12.012 8.438-2.175 1.709-2.918 3.048-3.988 5.562-1.557 1.91-2.365 2.884-4.816 3.332-2.97.909-4.5 2.536-6.746 4.668-3.48 3.226-6.997 6.33-10.688 9.313-4.872 3.945-9.646 7.99-14.39 12.087-3 2.587-6.014 5.151-9.07 7.67l-1.802 1.493q-1.694 1.401-3.402 2.784c-2.804 2.328-4.718 4.258-6.086 7.653-1.73 2.224-2.49 2.924-5.312 3.344-3.316.81-4.87 2.176-7.375 4.468l-2.325 2.083c-2.053 1.968-2.053 1.968-3.07 4.293-1.304 2.575-3.212 2.732-5.793 3.71-3.756 1.947-6.623 4.943-9.687 7.82-2.594 2.428-5.291 4.676-8.063 6.895-1.513 1.345-1.513 1.345-2.187 3.43-1.746 2.877-4.043 2.951-7.188 3.957-2.615 1.96-2.615 1.96-5 4.313-2.771 2.604-5.508 5.153-8.5 7.5-2.389 2.09-3.165 3.422-4.5 6.187l-4 2a349 349 0 0 0-4 5c-2.72 2.388-4.559 3.853-8 5a564 564 0 0 0-3.402 4.234c-3.08 3.403-6.781 6.231-10.598 8.766h-2l-.812 1.75c-1.957 3.708-3.117 5.893-7.188 7.25l-2 2c-3.692 3-3.692 3-6 3v2c-1.554 1.253-3.172 2.426-4.812 3.563-5.226 3.689-10.1 7.61-14.973 11.75C805 819 805 819 803 819l-1 3c-4.457 4-4.457 4-7 4l-.754 1.8c-1.427 2.519-2.85 3.697-5.183 5.388l-2.09 1.542C785 836 785 836 782 837a523 523 0 0 0-4 5c-4.255 3.83-4.255 3.83-7.187 4.5L769 847l-.902 1.832c-1.208 2.385-2.446 3.634-4.473 5.356l-1.773 1.542c-1.968 1.35-3.563 1.71-5.852 2.27l-1 2-1 2-4 1-.812 1.875c-1.54 2.755-3.233 2.949-6.075 4.031-3.698 1.914-6.497 4.88-9.52 7.707-2.396 2.206-4.847 4.248-7.405 6.262a380 380 0 0 0-11.313 9.313c-8.192 6.974-16.57 13.716-24.937 20.478-7.45 6.024-14.857 12.08-22.14 18.307-3.913 3.326-7.927 6.505-11.986 9.652a219 219 0 0 0-14.421 12.242c-3.313 2.955-6.818 5.636-10.36 8.309-2.066 1.856-2.844 3.365-4.031 5.824l-2.375.438c-3.652.782-4.462 2.588-6.625 5.562-4.505 4.835-4.505 4.835-8 6l-.773 1.73c-1.835 3.396-4.819 5.313-7.852 7.582a1617 1617 0 0 0-5.663 4.341c-2.877 2.264-5.577 4.713-8.259 7.202C586 1001 586 1001 584 1001v2c-1.645 1.473-1.645 1.473-3.812 3.063l-2.145 1.597C576 1009 576 1009 573 1010v3h-3l-.062 1.813c-1.49 3.474-4.55 3.81-7.938 5.187a89 89 0 0 0-4 4h-2v2l-2 1-2 3-4 2a120 120 0 0 0-3.125 2.625C542 1037 542 1037 540 1037v2c-2.334 2.012-4.048 3.016-7 4l-1 2-1.875.313c-2.385.512-2.385.512-3.562 3.124-1.856 3.043-3.216 3.568-6.563 4.563v2l-2.312.688c-3.267 1.595-3.88 3.246-5.688 6.312l-4 1-1.5 2.5c-1.5 2.5-1.5 2.5-3.312 3l-2.188.5c-4.212 3.053-4.212 3.053-7.125 7.25L493 1078l-1.746.367c-3.05.857-4.775 2.466-7.192 4.508l-2.93 2.457L478 1088l-3.258 2.762q-2.49 2.11-4.98 4.224a478 478 0 0 1-11.996 9.81c-3.46 2.757-6.896 5.54-10.329 8.329-.678.551-1.357 1.103-2.057 1.67a2548 2548 0 0 0-17.133 14.092 487 487 0 0 1-15.87 12.563c-2.962 2.278-5.265 4.472-7.377 7.55a283 283 0 0 1-5 5l-1.562 1.75c-1.438 1.25-1.438 1.25-3.239 1.621-2.794.8-4.538 2.156-6.824 3.941l-2.352 1.801c-2.026 1.89-2.865 3.416-4.023 5.887-2.13.799-3.733 1-6 1q-.035-30.654-.052-61.307-.007-14.232-.023-28.464-.015-12.401-.02-24.803 0-6.57-.01-13.139-.01-6.177-.008-12.356 0-2.273-.006-4.545-.007-3.093-.001-6.185l-.003-3.503C376 1013 376 1013 377 1011h121c.813-30.696.813-30.696-2-61l1-2c.133-2.892.21-5.763.246-8.656l.1-5.285q.072-4.178.13-8.355c.04-2.683.092-5.365.145-8.048l.026-2.535c.126-5.894.126-5.894 2.353-8.121v-1l126-1v-55c.54-45.357.54-45.357 2.222-47.708 2.344-1.703 3.772-1.662 6.656-1.653l3.047-.012 3.34.032h3.518c3.847.001 7.694.025 11.541.048q3.996.009 7.991.013c6.3.01 12.601.034 18.902.064 7.876.037 15.752.053 23.629.07 14.051.029 28.102.089 42.154.146V697l3-1v-1q16.843-.307 33.688-.562l2.525-.04c30.304-.456 60.48-.177 90.787.602V591h2zm33 1v1h13v-1zm42 0v1h9v-1zm11 0v1h5v-1zm13 0v1h8v-1zm15 0v1h10v-1zm27 0v1h9v-1zm15 0v1h5v-1zm10 0 4 1Zm5 0v1h5v-1zm-172 8v73h1v-73zm0 74v16h1v-16zM667 802v1h81v-1zM538 907v1h22v-1zm30 0v1h45v-1zm49 0v1h10v-1zm-120 44 1 2Zm-115 61v1h115v-1z"/><path d="M876 355h3c1.554 6.829.338 13.042-.812 19.875l-.542 3.492c-1.032 6.32-1.032 6.32-1.646 8.633l-2 1v30l2 1c.47 1.73.47 1.73.781 3.973l.364 2.478.355 2.611c.684 4.867 1.367 9.651 2.629 14.407.871 3.531.871 3.531.308 5.969-.708 4.148 1.077 7.708 2.563 11.562l2-1-.625 1.875L884 463l2 2c1.939 2.276 3.11 4.26 4.273 7.035 5.198 12.342 12.27 24.598 20.727 34.965l1.315 1.614c5.917 7.207 12.097 14.046 18.852 20.48 3.637 3.506 3.637 3.506 4.833 5.949 1.509 2.952 3.818 4.571 6.375 6.644l2.898 2.387c2.471 1.745 3.863 2.33 6.727 2.926 1.25 2.063 1.25 2.063 2 4h3v6H855l1 11c.076 2.435.118 4.871.114 7.307v1.956q-.002 3.124-.016 6.249l-.005 4.392q-.006 5.722-.024 11.446-.014 5.864-.02 11.726-.016 11.462-.049 22.924c-3.731 2.049-3.731 2.049-6.148 1.61l-2.227-.86-2.387-.887L843 633l-3.187-1.062L837 631l-3.062-.75c-3.812-1.622-5.395-4.037-7.938-7.25a177 177 0 0 0-4-2c-1.25-2.125-1.25-2.125-2-4h-3v-2l-4-2v-2h-2c-1.297-1.39-1.297-1.39-2.75-3.324l-1.594-2.12-1.656-2.244c-.547-.72-1.093-1.442-1.656-2.185C797 592.614 797 592.614 797 587c-1.375-2.03-2.872-3.856-4.5-5.687-2.534-3.908-4.948-8.89-4.078-13.594L789 566h-2c-3.004-11.016-3.131-21.734-3.062-33.062q.008-2.179.013-4.358.017-5.29.049-10.58h1l1 29v-30h-1c-.34-7.457.592-14.13 2.313-21.375l.646-2.941c1.08-4.676 1.972-7.924 5.041-11.684 4.082-6.124 6.167-12.667 6-20 .833-2.445 1.879-4.664 3-7h2c2.496-4.49 4.283-7.762 4-13 1.203-4.112 3.02-6.02 6-9 3.579-4.79 6.31-9.224 8-15l2-2 .902-1.879c1.639-3.166 4.09-5.462 6.54-8.023 1.77-2.384 2.188-4.18 2.558-7.098l3-1c1.125-1.833 1.125-1.833 2-4 .938-2.187.938-2.187 2-4l3-1a373 373 0 0 0 4-6 563 563 0 0 1 5-5q2.57-2.868 5.125-5.75c5.166-5.743 10.77-10.508 16.875-15.25zm2 2 1 4Zm-1 5v5h1v-5zm-1 5v6h1v-6zm-1 6v7h1v-7zm0 54v7h1v-7zm1 7 1 4Zm1 5 1 4Zm1 5 1 3Zm7 23 2 3v-3zm-93 18 1 2Zm-1 4 1 2Zm-1 3 1 3Zm-1 4 1 3Zm-1 4 1 3Zm-1 56v5h1v-5zm3 13 1 3Zm1 4 1 2Zm1 2 1 3ZM388.688 102.688l2.66-.016c5.817.061 11.015.894 16.652 2.328v2l2.93 1.102c17.727 6.783 31.685 16.165 41.582 32.695L454 143h2l.867 3.555a157 157 0 0 0 2.203 7.953c5.75 19.716 4.544 41.115-4.882 59.554C450.936 219.43 447.14 224.294 443 229l-2.02 2.309C430.61 242.41 418.18 248.304 404 253v2c-6.597 1.73-12.839 2.218-19.625 2.25l-2.421.027c-5.298-.026-9.863-.809-14.954-2.277v-2l-3.078-1.031c-9.34-3.246-16.919-7.076-24.922-12.969-2.758-1.937-2.758-1.937-4.937-2.937-4.939-2.545-8.676-5.817-11-10.875-1.177-2.552-2.42-4.706-4.028-7.032-10.19-15.805-11.048-36.455-7.441-54.432 2.063-9.269 5.845-17.167 10.844-25.161l1.088-1.757c3.197-4.896 6.878-8.275 11.911-11.244 2.755-1.554 2.755-1.554 5.375-4.25 6.928-6.128 16.609-10.04 25.188-13.312v-2c7.603-2.644 14.693-3.301 22.688-3.312M380 104v1h16v-1zm-6 1v1h5v-1zm24 0v1h5v-1zm-28 1 4 1Zm-53 45 1 2Zm-1 2 1 2Zm-1 3 1 3Zm-1 4 1 2Zm-1 3 1 4Zm-1 5v7h1v-7zm-1 8v12h1v-12zm1 12v7h1v-7zm1 7v5h1v-5zm1 5 1 4Zm1 4 1 2Zm1 3 1 2Zm1 2 1 2Zm1 3 1 2Zm1 2 1 2Zm1 2 1 2Zm52 38v1h5v-1zm21 0v1h7v-1zm-11 1v1h11v-1z"/><path d="M934 319c4.512-.366 4.512-.366 6.75 1.313C942 322 942 322 943 325l2.238 1.727c3.43 2.823 5.544 5.95 7.95 9.648l1.326 1.96c2.5 3.787 4.22 7.266 5.486 11.665.877 2.042.877 2.042 2.455 3.368 1.755 1.853 2.405 3.344 3.264 5.737.29.81.582 1.62.882 2.454 3.34 9.764 6.143 19.16 7.399 29.441l.356 2.819c2.858 23.97 3.07 54.424-12.043 74.868-2.231 2.572-4.262 3.863-7.313 5.313q-2.13 1.419-4.187 2.938l-2.106 1.527c-1.978 1.524-1.978 1.524-2.707 4.535l-1.75-.562c-2.178-.599-2.178-.599-3.992.05-7.069 1.602-15.12.194-21.258-3.488l-2.562-.375c-5.595-1.434-9.011-7.326-12.016-11.965-5.077-9.497-7.6-20.14-4.902-30.605.559-2.392.638-4.607.48-7.055h2c.182-.568.364-1.137.55-1.723 1.59-4.884 3.355-9.587 5.45-14.277h2l.313-3.25c.682-3.724 1.3-4.981 3.687-7.75 1.24-2.134 1.963-3.79 2.387-6.227.727-3.289 1.963-6.118 3.3-9.21C928.65 364.958 931.27 343.169 932 320l2 1zm-1 11v14h1v-14zm-1 15v6h1v-6zm-1 6v5h1v-5zm31 5 1 2Zm-32 1 1 4Zm33 1 1 2Zm-34 3 1 3Zm35 0 1 2Zm1 3 1 2Zm-37 1 1 3Zm38 2 1 2Zm-39 2 1 3Zm40 1 1 2Zm-41 2 1 3Zm42 1 1 3Zm1 4 1 3Zm-45 1 1 2Zm-1 3 1 2Zm47 0 1 4Zm-48 3 1 2Zm-1 2 1 2Zm50 0v6h1v-6zm-51 3 1 2Zm-1 2 1 2Zm53 2v7h1v-7zm1 8v24h1v-24zm-61 6 1 2Zm-1 2 1 2Zm-3 7 1 2Zm-1 2 1 2Zm-1 2 1 3Zm-1 3 1 2Zm-1 2 1 3Zm68 0v8h1v-8zm-69 3 1 3Zm-1 4 1 3Zm69 2 1 4Zm-70 2v5h1v-5zm69 3 1 4Zm-1 5 1 3Zm-1 4 1 3Zm-67 1 1 4Zm66 2 1 2Zm-1 3 1 2Zm-1 3 1 2Zm-61 4 1 2Zm1 2 1 2Zm87-77h2l2 2 2 1 1 3 2.32 2.293c17.772 17.953 24.073 50.418 25.055 74.582-.42 20.274-4.418 44.637-18.262 60.227-2.014 1.81-3.648 2.83-6.113 3.898l-1.973 1.07c-6.007 3.032-11.341 3.919-18.027 2.93-2.929-.99-5.4-2.341-8-4l-3.312-1.937c-4.775-3.665-6.276-7.862-7.399-13.61-1.583-13.43 5.985-25.293 11.59-36.965 1.81-3.79 3.498-7.614 5.121-11.488h2c1.142-1.782 1.142-1.782 2-4l-.504-1.87c-.595-2.555-.233-3.955.5-6.458l.693-2.422.749-2.5.736-2.547c.6-2.07 1.212-4.137 1.826-6.203h2c4.133-18.82 3.855-37.886 2-57m25 43 1 2Zm1 3 1 3Zm1 4 1 3Zm1 4 1 4Zm1 5 1 4Zm-33 3 1 3Zm34 3v5h1v-5zm-35 1 1 3Zm-1 3 1 3Zm-1 3-1 5 2-1zm38 0v23h1v-23zm-44 16 1 2Zm43 9v5h1v-5zm-1 7 1 4Zm-1 6 1 2Zm-1 4 1 2Zm-53 2 1 3Zm52 1 1 2Zm-53 2v14h1v-14zm1 15 1 3Zm1 3 1 2Zm-594 494h2v114h-2zm501-628h1v28h-1zM463 167h1c.058 3.937.094 7.875.125 11.813l.05 3.392.02 3.252.032 3C464 191 464 191 462 194z"/><path d="M992 400h1v23h-1zm-1 23h1c.266 6.95-.388 13.235-2 20h-1a755 755 0 0 1 2-20m-618 734h2v11c-2-2-2-2-2.195-4.164l.07-2.461.055-2.477zm552-674h18c-3.462 2.308-4.918 2.27-9 2.25l-3.187.016C928 485 928 485 925 483m-552 659h2v9h-2zm127-731c2.226 3.34 3.11 6.1 4 10-.45 2.223-.45 2.223-1 4a647 647 0 0 1-1.5-4.75l-.844-2.672C500 415 500 415 500 411M356 112a432 432 0 0 1-4.375 2.563l-2.46 1.44L347 117l-2-1a265 265 0 0 1 3.813-2.562l2.144-1.442C353 111 353 111 356 112m52-6c4.557.438 7.577.85 11 4-3.806-.672-7.352-1.727-11-3zm236 844 2 1-5 6-2-2zm-86-625c3.775 1.09 6.47 1.908 9 5-3.775-1.09-6.47-1.908-9-5m120 597 2 1-5 5-2-1zM377 566l2 1-5 6c0-3.517.824-4.371 3-7m284-102 9 3c-4 1-4 1-6.75-.375L661 465zm46-46c2.523 1.974 2.993 2.967 3.688 6.188L711 427c-1.991-2.986-2.941-5.597-4-9m151-49v3c-2.5 2.188-2.5 2.188-5 4 1.293-2.884 2.66-4.872 5-7M339 120l2 1-5 5-2-1zm643 418h11v1h-11zm-502 548 2 1-4 4-2-1zm170-141 2 1-4 4-2-1zm7-5 1 2-4 3-2-1zm34-28 1 2-4 3-2-1zm227-190 2 1-4 4-2-1zM460 199c.93 2.606 1.15 3.642.063 6.25L459 207c-1-2-1-2-.062-5.125zm-40 501c4.875 1.75 4.875 1.75 6 4-4.875-1.75-4.875-1.75-6-4m-11 444 2 1-3 3-2-1zm10-8 2 1-3 3-2-1zm17-14 2 1-3 3-2-1zm11-9 2 1-3 3-2-1zm175-145 2 1-3 3-2-1zm10-8 2 1-3 3-2-1zm29-24 2 1-3 3-2-1zm44-36 2 1-3 3-2-1zm182-152 2 1-3 3-2-1zm7-6 2 1-3 3-2-1zm36-30 2 1-3 3-2-1zM372 573v3l-3 2c1.875-3.875 1.875-3.875 3-5m22-27v3l-3 2c1.875-3.875 1.875-3.875 3-5m103-146c2 3 2 3 1.625 5.188L498 407zm494-8h1v8h-1zM421 111c2.438.375 2.438.375 5 1l1 2-6-2zm250 817h2v2l-4 1zM312 548v3h-3zm645-76v3h-3zm-75-19 2 3-1 3zM598 348l5 2-2 1zm-10-6 5 2-2 1zm-7-4 5 2-2 1zm-7-4 5 2-2 1zm-7-4 5 2-2 1zm-25-14 5 2-2 1zm-18-10 5 2-2 1zm-7-4 5 2-2 1zm-126 857 2 1-4 2zm67-55 2 1-4 2zm225-186 2 1-4 2zm11-9 2 1-4 2zm6-5 2 1-4 2zm17-14 2 1-4 2zm164-137 2 1-4 2zm-515-2 4 2h-3zm-4-3 4 2h-3zm550-21 2 1-4 2zm-589-7 4 2h-3zm-11-8 4 2h-3zm643-21 2 1-4 2zm8-7 2 1-4 2zm27-23 2 1-4 2zm-661-35v3l-2 1zm614-85 4 2h-3zm-6-5 4 2h-3zm45-72 1 3-2 2zm-650-46v3l-2 1zm4-5v3l-2 1zm536-57 2 1-4 2zM360 108l3 1-5 1zm175 749 2 4-2-1zm-54-90h1v5h-1zm423-33v3l-2-1zM274 555l4 2-4-1zm697-24 3 3-3-1zm-278-66 2 1-4 1zM381 353l2 1-3 2zm-45-116 3 3-3-1zm126-75h1v5h-1zm-76 1001 2 1h-3zm39-32 2 1h-3zm4-3 2 1h-3zm12-10 2 1h-3zm10-8 2 1h-3zm23-19 2 1h-3zm13-11 2 1h-3zm150-124 2 1h-3zm-60-74 4 1Zm157-6 2 1h-3zm-185-2 3 1h-3zM391 769l3 1h-3zm-33-24 3 1h-3zm-14-10 3 1h-3zm562-3 2 1h-3zm-572-4 3 1h-3zm121-4 3 1h-3zm466-2h2v2h-2zm-469 0 3 1h-3zm-3-2 3 1h-3zm-3-2 3 1h-3zm-7-5 3 1h-3zm-3-2 3 1h-3zm500-4 2 1h-3zm13-11 2 1h-3zm-555-14 3 1h-3zm576-4 2 1h-3zm5-4 2 1h-3zm-637-59v3Zm42-52v3Zm573-14 3 1h-3zm-36-70 3 1h-3zm-212-64 2 1-1 2zm-366-6v3Zm160-2 1 4Zm-153-7v3Zm490-5v3Zm-484-3v3Zm638-4 1 4Zm-632-4v3Zm16-21v3Zm5-7v3Zm231-1 3 1h-3zm-17-10 3 1h-3zm-195-76 2 1h-3zm-35-16 4 1Zm-17-8 3 1h-3zm-3-2 3 1h-3zm-3-2 3 1h-3zm121-46 1 4Zm0-37 1 4Zm-118-41 2 1h-3zm86-2 3 1h-3zm139 767 3 1Zm23-4h2l-1 2zm-49-11 2 2h-2zm418-180 1 2-2-1zm19-16 1 2-2-1zm-160-54 2 2h-2zm-438-56 2 1-2 1zm17-20 2 1-2 1zm595-4 3 1Zm-14 0 3 1Zm-554-29 2 1-2 1zm276-49 1 2-2-1zm101-7h2l-1 2zm-432-84 2 1-2 1zm495-6 2 1-2 1zM363 107l3 1Zm13 1064 2 1Zm36-29 2 1Zm50-41 2 1Zm6-5 2 1Zm30-25 2 1Zm45-35 2 1Zm122-103 2 1Zm46-38 2 1Zm-148-14 2 1Zm166-1 2 1Zm-133-5 2 1Zm145-5 2 1Zm241-202 2 1Zm14-132 2 1Zm-19 0 2 1Zm-2-1 2 1Zm24-1 2 1Zm-77-52 2 1Zm-2-1 2 1Zm27-1 2 1Zm2-1 2 1Zm-253-16 2 1Zm-37 0 2 1Zm-10-6 2 1Zm-2-1 2 1Zm-15-9 2 1Zm-101-59 2 1Zm117-10 2 1Zm-3-2 2 1Zm-5-3 2 1Zm-139-2 2 1Zm134-1 2 1Zm-136 0 2 1Zm131-3 2 1Zm-3-2 2 1Zm-2-1 2 1Zm-3-2 2 1Zm-2-1 2 1Zm-2-1 2 1Zm-2-1 2 1Zm-3-2 2 1Zm-5-3 2 1Zm-3-2 2 1Zm-2-1 2 1Zm-7-4 2 1Zm-10-6 2 1Zm-7-4 2 1Zm-7-4 2 1Zm-16-9 2 1Zm-2-1 2 1Zm-7-4 2 1Zm388-2 2 1Zm-395-2 2 1Zm-11-6 2 1Zm-7-4 2 1Zm-7-4 2 1Zm-2-1 2 1Zm-2-1 2 1Zm-7-4 2 1Zm-2-1 2 1Zm-5-3 2 1Zm-2-1 2 1Zm-7-4 2 1Zm-2-1 2 1Zm-2-1 2 1Zm-16-9 2 1Zm-9-5 2 1Zm-2-1 2 1Zm-52-16 2 1Zm3-1 2 1Zm-47 0 2 1Zm50-1 2 1Zm-53 0 2 1Zm56-1 2 1Zm-61-1 2 1Zm-2-1 2 1Zm-2-1 2 1Zm73-1 2 1Zm13-126 2 1Zm-8-6 2 1Zm-8-4 2 1Zm-63 0 2 1Z"/></g>`;
        default: return '';
      }
    }

    // ---- grade-1 braille transliteration (real dots, not decorative) ----
    // Standard 6-dot cell numbering:  1 4
    //                                 2 5
    //                                 3 6
    const BRAILLE_LETTERS = {
      a:[1], b:[1,2], c:[1,4], d:[1,4,5], e:[1,5], f:[1,2,4], g:[1,2,4,5], h:[1,2,5], i:[2,4], j:[2,4,5],
      k:[1,3], l:[1,2,3], m:[1,3,4], n:[1,3,4,5], o:[1,3,5], p:[1,2,3,4], q:[1,2,3,4,5], r:[1,2,3,5], s:[2,3,4], t:[2,3,4,5],
      u:[1,3,6], v:[1,2,3,6], w:[2,4,5,6], x:[1,3,4,6], y:[1,3,4,5,6], z:[1,3,5,6]
    };
    const BRAILLE_DIGIT_LETTER = {'1':'a','2':'b','3':'c','4':'d','5':'e','6':'f','7':'g','8':'h','9':'i','0':'j'};
    const BRAILLE_NUMBER_SIGN = [3,4,5,6];

    // digits get the number-sign cell once per run, then a/b/c... stand in for 1/2/3...;
    // letters map directly; anything else (space, punctuation) becomes a blank cell
    function textToBrailleCells(text){
      const cells = [];
      let numberMode = false;
      for (const ch of String(text||'')){
        if (/[0-9]/.test(ch)){
          if (!numberMode){ cells.push(BRAILLE_NUMBER_SIGN); numberMode = true; }
          cells.push(BRAILLE_LETTERS[BRAILLE_DIGIT_LETTER[ch]]);
        } else if (/[a-zA-Z]/.test(ch)){
          numberMode = false;
          cells.push(BRAILLE_LETTERS[ch.toLowerCase()] || []);
        } else {
          numberMode = false;
          cells.push([]);
        }
      }
      return cells;
    }
    function brailleMarkup(text, cx, cy, color, dotR, dotGap, cellGap){
      const cells = textToBrailleCells(text);
      if (!cells.length) return '';
      const cellWidth = dotGap + cellGap;
      const totalWidth = cells.length*cellWidth - cellGap;
      const positions = { 1:[0,0], 2:[0,1], 3:[0,2], 4:[1,0], 5:[1,1], 6:[1,2] };
      let x = cx - totalWidth/2, out = '';
      cells.forEach(dotsInCell=>{
        dotsInCell.forEach(d=>{
          const [col,row] = positions[d];
          out += `<circle cx="${x+col*dotGap}" cy="${cy+row*dotGap}" r="${dotR}" fill="${color}"/>`;
        });
        x += cellWidth;
      });
      return out;
    }

    // ---- WCAG contrast ratio — a practical, checkable proxy for ADA's
    // qualitative "high contrast, non-glare finish" requirement (ADA itself
    // doesn't cite this exact formula, but it's a reasonable stand-in) ----
    function hexToRgb(hex){
      hex = String(hex).replace('#','');
      if (hex.length===3) hex = hex.split('').map(c=>c+c).join('');
      const num = parseInt(hex,16);
      return [(num>>16)&255, (num>>8)&255, num&255];
    }
    function relLuminance(hex){
      const [r,g,b] = hexToRgb(hex).map(v=>{
        v/=255;
        return v<=0.03928 ? v/12.92 : Math.pow((v+0.055)/1.055,2.4);
      });
      return 0.2126*r+0.7152*g+0.0722*b;
    }
    function contrastRatio(hex1,hex2){
      const L1=relLuminance(hex1), L2=relLuminance(hex2);
      const lighter=Math.max(L1,L2), darker=Math.min(L1,L2);
      return (lighter+0.05)/(darker+0.05);
    }

    function archPathD(x,y,w,h){
      const topY = y + h*0.24;
      return `M ${x} ${y+h} L ${x} ${topY} A ${w/2} ${topY-y} 0 0 1 ${x+w} ${topY} L ${x+w} ${y+h} Z`;
    }
    function wavyPathD(x,y,w,h){
      const iw = w*0.06;
      return `M ${x+iw} ${y} L ${x+w-iw} ${y} C ${x+w-iw*2.4} ${y+h*0.3}, ${x+w-iw*2.4} ${y+h*0.7}, ${x+w-iw} ${y+h} L ${x+iw} ${y+h} C ${x+iw*2.4} ${y+h*0.7}, ${x+iw*2.4} ${y+h*0.3}, ${x+iw} ${y} Z`;
    }
    function diagonalPathD(x,y,w,h){
      const cut = Math.min(w,h)*0.22;
      return `M ${x} ${y} L ${x+w-cut} ${y} L ${x+w} ${y+cut} L ${x+w} ${y+h} L ${x} ${y+h} Z`;
    }
    function bowedPathD(x,y,w,h){
      // straight on three sides, left edge bows outward in a gentle convex curve
      const b = w*0.09;
      return `M ${x+b} ${y} Q ${x-w*0.05} ${y+h/2} ${x+b} ${y+h} L ${x+w} ${y+h} L ${x+w} ${y} Z`;
    }
    function shapeMarkup(shape, x, y, w, h, attrs, rx){
      rx = (rx===undefined) ? 6 : rx;
      switch(shape){
        case 'oval': return `<ellipse cx="${x+w/2}" cy="${y+h/2}" rx="${w/2}" ry="${h/2}" ${attrs}/>`;
        case 'circle': { const r=Math.min(w,h)/2; return `<ellipse cx="${x+w/2}" cy="${y+h/2}" rx="${r}" ry="${r}" ${attrs}/>`; }
        case 'arch': return `<path d="${archPathD(x,y,w,h)}" ${attrs}/>`;
        case 'wavy': return `<path d="${wavyPathD(x,y,w,h)}" ${attrs}/>`;
        case 'bowed': return `<path d="${bowedPathD(x,y,w,h)}" ${attrs}/>`;
        case 'diagonal': return `<path d="${diagonalPathD(x,y,w,h)}" ${attrs}/>`;
        default: return `<rect x="${x}" y="${y}" width="${w}" height="${h}" rx="${rx}" ${attrs}/>`;
      }
    }
    function standoffPoints(shape, x, y, w, h){
      if (shape==='circle' || shape==='oval'){
        const rx = (shape==='circle') ? Math.min(w,h)/2 : w/2;
        const ry = (shape==='circle') ? Math.min(w,h)/2 : h/2;
        const cx = x+w/2, cy = y+h/2, k = 0.78;
        return [45,135,225,315].map(deg=>{
          const rad = deg*Math.PI/180;
          return [cx + rx*k*Math.cos(rad), cy + ry*k*Math.sin(rad)];
        });
      }
      const inset = (shape==='rectangle') ? 18 : Math.max(w,h)*0.09;
      if (shape==='arch'){
        // Top of the plate is cut away by the arc except at the very center
        // (see archPathD) — the flat vertical sides don't start until topY,
        // so top standoffs need to sit at/below that line, not at a generic
        // top-corner inset (which landed in the cut-away area above the arc).
        const topY = y + h*0.24;
        return [[x+inset, topY+inset], [x+w-inset, topY+inset], [x+inset, y+h-inset], [x+w-inset, y+h-inset]];
      }
      if (shape==='diagonal'){
        // Top-right corner is sliced off by a diagonal cut (see diagonalPathD)
        // — shift that standoff left, off the missing corner and onto the
        // sign's actual top edge.
        const cut = Math.min(w,h)*0.22;
        return [[x+inset, y+inset], [x+w-cut-inset, y+inset], [x+inset, y+h-inset], [x+w-inset, y+h-inset]];
      }
      if (shape==='bowed'){
        // Left edge bows outward from x+b rather than running straight down
        // x (see bowedPathD) — left standoffs need to start from that bowed
        // edge, not from the plain rectangle inset (which sat left of the
        // actual plate edge, off the sign).
        const b = w*0.09;
        const leftX = x + b + inset*0.5;
        return [[leftX, y+inset], [x+w-inset, y+inset], [leftX, y+h-inset], [x+w-inset, y+h-inset]];
      }
      return [[x+inset,y+inset],[x+w-inset,y+inset],[x+inset,y+h-inset],[x+w-inset,y+h-inset]];
    }
    // ---- accent style overlays (drawn on top of / behind the base plate) ----
    function accentColorHex(){
      return state.accentColor==='custom' ? state.accentCustomColor : ACCENT_COLORS[state.accentColor].hex;
    }
    function offsetShadowMarkup(shape, px, py, w, h, color){
      const dx = w*0.055, dy = h*0.07;
      return shapeMarkup(shape, px+dx, py+dy, w, h, `fill="${color}"`, 6);
    }
    function accentOverlayMarkup(accent, px, py, w, h, color){
      switch(accent){
        case 'stripe':
          return `<rect x="${px}" y="${py}" width="${w*0.16}" height="${h}" fill="${color}"/>`;
        case 'bands': {
          const bandH = h*0.15;
          return `<rect x="${px}" y="${py}" width="${w}" height="${bandH}" fill="${color}"/>
                  <rect x="${px}" y="${py+h-bandH}" width="${w}" height="${bandH}" fill="${color}"/>`;
        }
        case 'split':
          return `<polygon points="${px+w},${py} ${px+w},${py+h} ${px+w*0.35},${py+h}" fill="${color}"/>`;
        case 'banner': {
          const y0 = py+h*0.32, y1 = py+h*0.46;
          return `<path d="M ${px} ${y0+h*0.06} C ${px+w*0.3} ${y0-h*0.08}, ${px+w*0.7} ${y0+h*0.1}, ${px+w} ${y0-h*0.02}
                   L ${px+w} ${y1-h*0.02} C ${px+w*0.7} ${y1+h*0.1}, ${px+w*0.3} ${y1-h*0.08}, ${px} ${y1+h*0.06} Z"
                   fill="${color}" opacity="0.92"/>`;
        }
        default: return '';
      }
    }
    // Acrylic is the only material now, and it's always custom-colored — a
    // flat, slightly glossy fill rather than any of the old drawn textures.
    function materialFillDefs(uid, customColor){
      const c = customColor || '#C6A05F';
      return `<linearGradient id="fill-${uid}" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="${c}"/><stop offset="1" stop-color="${c}"/></linearGradient>`;
    }
    function shadowFilter(mounting){
      const isStandoff = mounting==='standoff';
      const dx = isStandoff?10:3, dy = isStandoff?14:4, b = isStandoff?10:3;
      return `filter:drop-shadow(${dx}px ${dy}px ${b}px rgba(0,0,0,0.45))`;
    }

    function buildChipRow(container, options, key, disableFn, onSelect){
      container.innerHTML = '';
      Object.keys(options).forEach(k=>{
        const opt = options[k];
        const btn = document.createElement('button');
        btn.className = 'ss-chip';
        btn.type = 'button';
        btn.textContent = opt.label;
        if (disableFn && disableFn(k, opt)) btn.classList.add('disabled');
        if (state[key] === k) btn.classList.add('active');
        btn.addEventListener('click', ()=>{
          if (btn.classList.contains('disabled')) return;
          state[key] = k;
          if (onSelect) onSelect(k);
          render();
        });
        container.appendChild(btn);
      });
    }

    // Icons are multi-select (a sign can carry Accessible + No Smoking + Audio
    // Accessible all at once) — "None" is a clear-all action rather than a
    // normal member of the selection array.

    let lastTemplate = state.template;

    function render(){
      // Auto-suggest headline/detail/floorNumber/footerText/size when the
      // template changes, unless the customer has typed/picked their own —
      // this must run BEFORE size/plateW are read below, or a template's
      // suggested size only takes effect one render late (the plate would
      // stay the old dimensions until the next unrelated interaction).
      if (state.template !== lastTemplate){
        const t = TEMPLATES[state.template];
        if (!state.headlineManual) state.headline = t.headline;
        if (!state.detailManual) state.detail = t.detail;
        if (!state.floorNumberManual && t.floorNumber!==undefined) state.floorNumber = t.floorNumber;
        if (!state.footerTextManual && t.footerText!==undefined) state.footerText = t.footerText;
        if (!state.sizeManual && t.defaultSize) state.size = t.defaultSize;
        lastTemplate = state.template;
      }

      const shapeName = state.shape;
      if (ACCENTS[state.accent].incompatibleShapes && ACCENTS[state.accent].incompatibleShapes.includes(shapeName)){
        state.accent = 'none';
      }
      // Backplate is sold as the "Offset Shadow" accent — picking that look IS
      // the paid backplate add-on, so Material (which is what actually prices
      // the variant) tracks the accent choice rather than being picked
      // separately. Matches the same pattern in the other sign builders.
      state.material = (state.accent==='shadow') ? 'backplate' : 'standard';
      // Every sign we sell is ADA-compliant now — no toggle, no non-compliant
      // option. Typeface is locked to sans-serif per §703.2.2.
      if (state.typeface!=='sans'){
        state.typeface = 'sans';
      }

      const size = SIZES[state.size];
      const typeface = TYPEFACES[state.typeface];
      const plateW = 320, plateH = plateW * (size.h/size.w);
      const vbW = plateW+120, vbH = plateH+120;
      const px = (vbW-plateW)/2, py = (vbH-plateH)/2;
      const uid = state.material;
      const clipId = 'clip-' + sectionId + '-' + uid;

      let defs = materialFillDefs(uid, state.plateColor);
      const plateFill = `url(#fill-${uid})`;
      const overlay = '';
      defs += `<clipPath id="${clipId}">${shapeMarkup(shapeName, px, py, plateW, plateH, '', 6)}</clipPath>`;

      let standoffs = '';
      if (state.mounting==='standoff'){
        standoffs = standoffPoints(shapeName, px, py, plateW, plateH)
          .map(([cx,cy])=>`<circle cx="${cx}" cy="${cy}" r="5" fill="#8E7442"/><circle cx="${cx}" cy="${cy}" r="2" fill="#C6A05F"/>`).join('');
      }
      const glow = '';

      if (!state.textColorManual){
        state.textColor = MATERIALS[state.material].engrave;
      }
      const engraveColor = state.textColor;
      // Both current materials are acrylic (just different thickness), so the
      // lighter stroke always applies — revisit if a non-acrylic option is added.
      const plateStroke = 'rgba(255,255,255,0.6)';
      const plateShadow = shadowFilter(state.mounting);

      // ---- accent overlays: offset shadow draws BEHIND the plate; the rest draw
      // on top, clipped to the plate's own outline so nothing spills past the edge ----
      const accentColorValue = accentColorHex();
      const shadowBehindMarkup = state.accent==='shadow'
        ? offsetShadowMarkup(shapeName, px, py, plateW, plateH, accentColorValue) : '';
      const onTopAccentMarkup = (state.accent!=='none' && state.accent!=='shadow')
        ? accentOverlayMarkup(state.accent, px, py, plateW, plateH, accentColorValue) : '';

      const textColor = engraveColor;

      const headlineDisplay = state.headline.toUpperCase();
      const detailDisplay = state.detail.toUpperCase();
      const hasDetail = !!state.detail.trim();
      const layoutKind = TEMPLATES[state.template].layout || 'standard';

      // Each non-rectangular shape curves inward differently — a flat margin
      // is only safe for shapes with straight sides. Wavy pinches in by
      // ~14.4% of width at the vertical middle (exactly where content sits),
      // and arch's dome narrows above ~24% of height, so both need their own
      // clearance instead of one shared percentage.
      const SIDE_MARGIN = { rectangle:0.06, oval:0.14, circle:0.14, porthole:0.14, arch:0.06, wavy:0.19, bowed:0.07, diagonal:0.06 };
      const TOP_MARGIN  = { arch:0.30 };
      const sideMarginFrac = SIDE_MARGIN[shapeName] ?? 0.06;
      const minTopFrac = TOP_MARGIN[shapeName] || 0;

      // stripe/bands accents carve out dedicated space, so keep content
      // clear of those zones rather than drawing on top of them
      const hasStripe = state.accent==='stripe';
      const hasBands = state.accent==='bands';
      const contentLeft = px + plateW*(hasStripe ? Math.max(0.16, sideMarginFrac) : sideMarginFrac);
      const contentTop = py + plateH*Math.max(hasBands ? 0.15 : 0, minTopFrac);
      const contentBottom = py + plateH*(1 - (hasBands ? 0.15 : 0));
      const contentRight = px + plateW*(1-sideMarginFrac);
      const cx = (contentLeft+contentRight)/2;
      const usableW = (contentRight-contentLeft) * 0.96;
      const usableH = contentBottom - contentTop;

      // Real physical scale: plateW px corresponds to size.w inches, so every
      // measurement below uses the actual ADA figures at this sign's true
      // scale rather than an arbitrary percentage of the plate.
      const pxPerInch = plateW / size.w;
      const inchPx = (n) => n * pxPerInch;

      const topMargin = inchPx(0.5);
      const bottomMargin = inchPx(0.5);
      const gapPictoToText = inchPx(0.4);
      const gapHeadlineToDetail = inchPx(0.25);
      const gapTextToBraille = inchPx(0.375); // §703.3.1 minimum, shown at its actual value
      let brailleDotR = inchPx(0.0615/2);
      let brailleDotGap = inchPx(0.0925);
      let brailleCellGap = inchPx(0.2705);

      let content, headFit, pictoSize, brailleScaled = false, brailleSourceText;

      if (layoutKind === 'stairId'){
        // Stairwell floor-level ID sign (IBC 1022.9/1023.9 style): a small
        // header (stair label + roof-access note), a single giant floor
        // number as the sign's dominant element, and a footer paragraph
        // giving the floor range and exit-discharge direction.
        const gapHeaderToNumber = inchPx(0.3);
        const gapNumberToFooter = inchPx(0.3);
        const reserved = topMargin + bottomMargin + gapHeaderToNumber + gapNumberToFooter + gapTextToBraille;
        const remaining = Math.max(inchPx(1), usableH - reserved - inchPx(0.5));
        const headerZoneH = remaining * 0.24;
        const numberZoneH = remaining * 0.42;
        const footerZoneH = remaining * 0.34;

        const headerTop = contentTop + topMargin;
        const headFitLocal = fitWrappedTextMeasured(headlineDisplay, usableW, headerZoneH*0.6, inchPx(1.0), 8, typeface.family, typeface.weight, 1.15);
        const headLineH = headFitLocal.fontSize*1.15;
        const headBlockH = headFitLocal.lines.length*headLineH;
        const headlineMarkup = headFitLocal.lines.map((line,i)=>{
          const y = headerTop + (i+0.85)*headLineH;
          return `<text x="${cx}" y="${y}" text-anchor="middle" font-family="${typeface.family}" font-weight="${typeface.weight}" font-size="${headFitLocal.fontSize}" fill="${textColor}">${escapeXml(line)}</text>`;
        }).join('');
        let detailMarkup = '';
        let headerBottom = headerTop + headBlockH;
        if (hasDetail){
          const detFit = fitWrappedTextMeasured(detailDisplay, usableW, headerZoneH*0.4, inchPx(0.55), 7, typeface.family, '600', 1.2);
          const detLineH = detFit.fontSize*1.2;
          const detTop = headerBottom + inchPx(0.06);
          detailMarkup = detFit.lines.map((line,i)=>{
            const y = detTop + (i+0.85)*detLineH;
            return `<text x="${cx}" y="${y}" text-anchor="middle" font-family="-apple-system,sans-serif" font-weight="600" font-size="${detFit.fontSize}" fill="${textColor}" opacity="0.9">${escapeXml(line)}</text>`;
          }).join('');
          headerBottom = detTop + detFit.lines.length*detLineH;
        }

        // The floor number is the dominant element — sized to fill the
        // number zone by height first, then capped by width so a two-digit
        // floor ("12") never runs past the plate.
        const numberZoneTop = headerTop + headerZoneH + gapHeaderToNumber;
        const numberText = state.floorNumber || '';
        const numMaxFont = Math.min(numberZoneH, inchPx(6));
        const numFontSize = fitFontSizeByMeasurement(numberText, usableW*0.7, numMaxFont, 10, typeface.family, '800');
        const numberY = numberZoneTop + numberZoneH/2 + numFontSize*0.36;
        const numberMarkup = numberText
          ? `<text x="${cx}" y="${numberY}" text-anchor="middle" font-family="${typeface.family}" font-weight="800" font-size="${numFontSize}" fill="${textColor}">${escapeXml(numberText)}</text>`
          : '';

        // Footer paragraph — wraps naturally; typed as one flowing sentence
        // ("1 THROUGH 4  ↓ DOWN TO LEVEL 1 FOR EXIT DISCHARGE") rather than
        // requiring the customer to manually break lines.
        const footerTop = numberZoneTop + numberZoneH + gapNumberToFooter;
        const footerDisplay = state.footerText.toUpperCase();
        const footFit = fitWrappedTextMeasured(footerDisplay, usableW, footerZoneH, inchPx(0.7), 7, typeface.family, '600', 1.25);
        const footLineH = footFit.fontSize*1.25;
        const footBlockH = footFit.lines.length*footLineH;
        const footBlockTop = footerTop + Math.max(0, (footerZoneH-footBlockH)/2);
        const footerMarkup = footFit.lines.map((line,i)=>{
          const y = footBlockTop + (i+0.85)*footLineH;
          return `<text x="${cx}" y="${y}" text-anchor="middle" font-family="-apple-system,sans-serif" font-weight="600" font-size="${footFit.fontSize}" fill="${textColor}" opacity="0.92">${escapeXml(line)}</text>`;
        }).join('');
        const footerBlockBottom = footBlockTop + footBlockH;

        brailleSourceText = [state.headline, hasDetail ? state.detail : '', numberText, state.footerText].filter(Boolean).join(' ');
        const brailleCellsForWidth = textToBrailleCells(brailleSourceText.toLowerCase());
        const naturalBrailleW = brailleCellsForWidth.length
          ? brailleCellsForWidth.length*(brailleDotGap+brailleCellGap) - brailleCellGap : 0;
        if (naturalBrailleW > usableW*0.98 && naturalBrailleW > 0){
          const scale = (usableW*0.98) / naturalBrailleW;
          brailleDotR *= scale; brailleDotGap *= scale; brailleCellGap *= scale;
          brailleScaled = true;
        }
        const brailleY = footerBlockBottom + gapTextToBraille + brailleDotR;

        headFit = headFitLocal;
        pictoSize = numFontSize; // stands in for "dominant element size" in the compliance panel below
        content = `
          ${headlineMarkup}
          ${detailMarkup}
          ${numberMarkup}
          ${footerMarkup}
          ${state.headline ? brailleMarkup(brailleSourceText, cx, brailleY, textColor, brailleDotR, brailleDotGap, brailleCellGap) : ''}
        `;

      } else if (layoutKind === 'floorLevel'){
        // Compact floor-level marker: headline with an inline icon (e.g. the
        // exit-discharge star) beside it, an optional smaller area label
        // below, then braille — matching common corridor/stairwell "LEVEL 1"
        // strip signs rather than the taller icon-above-text life-safety layout.
        const reserved = topMargin + bottomMargin + gapTextToBraille;
        const remaining = Math.max(inchPx(1), usableH - reserved - inchPx(0.4));
        const headlineZoneH = remaining * (hasDetail ? 0.62 : 1);
        const detailZoneH = hasDetail ? remaining * 0.38 : 0;

        const iconKey = TEMPLATES[state.template].icon;
        const headMaxFont = Math.min(headlineZoneH, inchPx(1.6));
        // Reserve room for the icon by fitting the headline to a narrower
        // width first, then sizing the icon off that same font size so the
        // two scale together rather than the icon being a fixed proportion.
        const provisionalFont = fitFontSizeByMeasurement(headlineDisplay, usableW*0.62, headMaxFont, 8, typeface.family, typeface.weight);
        const iconSize = iconKey ? provisionalFont*1.15 : 0;
        const iconGap = iconKey ? inchPx(0.25) : 0;
        const headFitLocal = { fontSize: provisionalFont, lines: wrapTextMeasured(headlineDisplay, usableW - iconSize - iconGap, provisionalFont, typeface.family, typeface.weight) };
        const headLineH = headFitLocal.fontSize*1.15;
        const headBlockW = Math.max(...headFitLocal.lines.map(l=>measureTextWidth(l, headFitLocal.fontSize, typeface.family, typeface.weight)), 0);
        const rowW = headBlockW + (iconKey ? iconGap+iconSize : 0);
        const rowLeft = cx - rowW/2;
        const headBlockTop = contentTop + topMargin + Math.max(0, (headlineZoneH - headFitLocal.lines.length*headLineH)/2);
        const headlineMarkup = headFitLocal.lines.map((line,i)=>{
          const y = headBlockTop + (i+0.85)*headLineH;
          return `<text x="${rowLeft}" y="${y}" text-anchor="start" font-family="${typeface.family}" font-weight="${typeface.weight}" font-size="${headFitLocal.fontSize}" fill="${textColor}">${escapeXml(line)}</text>`;
        }).join('');
        const iconX = rowLeft + headBlockW + iconGap;
        const iconY = headBlockTop + (headFitLocal.lines.length*headLineH)/2 - iconSize/2;
        const iconMarkup = iconKey
          ? (iconImages[iconKey]
              ? `<image href="${iconImages[iconKey]}" x="${iconX}" y="${iconY}" width="${iconSize}" height="${iconSize}"/>`
              : `<g transform="translate(${iconX}, ${iconY}) scale(${iconSize/36})">${iconPath(iconKey, textColor)}</g>`)
          : '';

        let detailMarkup = '';
        let detailBlockBottom = contentTop + topMargin + headlineZoneH;
        if (hasDetail){
          const detTop = contentTop + topMargin + headlineZoneH;
          const detFit = fitWrappedTextMeasured(detailDisplay, usableW, detailZoneH, inchPx(0.4), 7, typeface.family, '600', 1.2);
          const detLineH = detFit.fontSize*1.2;
          const detBlockH = detFit.lines.length*detLineH;
          const detBlockTop = detTop + Math.max(0, (detailZoneH-detBlockH)/2);
          detailBlockBottom = detBlockTop + detBlockH;
          detailMarkup = detFit.lines.map((line,i)=>{
            const y = detBlockTop + (i+0.85)*detLineH;
            return `<text x="${cx}" y="${y}" text-anchor="middle" font-family="-apple-system,sans-serif" font-weight="600" font-size="${detFit.fontSize}" fill="${textColor}" opacity="0.9">${escapeXml(line)}</text>`;
          }).join('');
        }

        brailleSourceText = state.headline + (hasDetail ? ' ' + state.detail : '');
        const brailleCellsForWidth = textToBrailleCells(brailleSourceText.toLowerCase());
        const naturalBrailleW = brailleCellsForWidth.length
          ? brailleCellsForWidth.length*(brailleDotGap+brailleCellGap) - brailleCellGap : 0;
        if (naturalBrailleW > usableW*0.98 && naturalBrailleW > 0){
          const scale = (usableW*0.98) / naturalBrailleW;
          brailleDotR *= scale; brailleDotGap *= scale; brailleCellGap *= scale;
          brailleScaled = true;
        }
        const brailleY = detailBlockBottom + gapTextToBraille + brailleDotR;

        headFit = headFitLocal;
        pictoSize = iconSize;
        content = `
          ${headlineMarkup}
          ${iconMarkup}
          ${detailMarkup}
          ${state.headline ? brailleMarkup(brailleSourceText, cx, brailleY, textColor, brailleDotR, brailleDotGap, brailleCellGap) : ''}
        `;

      } else {
        // ---- standard layout (Exit Stairs / Area of Refuge / Fire Elevator): icon above, headline, optional detail, braille ----
        // Braille field allocation: split whatever's left after margins/gaps
        // between the pictogram, headline, and (if present) detail zones.
        const reserved = topMargin + bottomMargin + gapPictoToText + gapTextToBraille + (hasDetail ? gapHeadlineToDetail : 0);
        const remaining = Math.max(inchPx(1), usableH - reserved - inchPx(0.5)); // 0.5" reserved for the braille block itself
        const pictoZoneH = remaining * (hasDetail ? 0.38 : 0.42);
        const headlineZoneH = remaining * (hasDetail ? 0.40 : 0.58);
        const detailZoneH = hasDetail ? remaining * 0.22 : 0;

        const pictoZoneTop = contentTop + topMargin;
        const pictoZoneBottom = pictoZoneTop + pictoZoneH;
        const headlineTop = pictoZoneBottom + gapPictoToText;
        const headlineBottomZone = headlineTop + headlineZoneH;
        const detailTop = hasDetail ? headlineBottomZone + gapHeadlineToDetail : headlineBottomZone;
        const detailBottomZone = hasDetail ? detailTop + detailZoneH : detailTop;

        // Headline wraps across multiple lines when needed — "IN FIRE EMERGENCY
        // DO NOT USE ELEVATOR" is far longer than anything Restroom Studio's
        // single-line labels handled, so this uses real measurement to both
        // wrap AND size, not an estimate.
        const headFitLocal = fitWrappedTextMeasured(headlineDisplay, usableW, headlineZoneH, inchPx(1.1), 8, typeface.family, typeface.weight, 1.18);
        const headLineH = headFitLocal.fontSize*1.18;
        const headBlockH = headFitLocal.lines.length*headLineH;
        const headBlockTop = headlineTop + Math.max(0, (headlineZoneH-headBlockH)/2);
        const headlineMarkup = headFitLocal.lines.map((line,i)=>{
          const y = headBlockTop + (i+0.85)*headLineH;
          return `<text x="${cx}" y="${y}" text-anchor="middle" font-family="${typeface.family}" font-weight="${typeface.weight}" font-size="${headFitLocal.fontSize}" fill="${textColor}">${escapeXml(line)}</text>`;
        }).join('');

        let detailMarkup = '';
        let detailBlockBottom = headlineBottomZone;
        if (hasDetail){
          const detFit = fitWrappedTextMeasured(detailDisplay, usableW, detailZoneH, inchPx(0.6), 7, typeface.family, '600', 1.22);
          const detLineH = detFit.fontSize*1.22;
          const detBlockH = detFit.lines.length*detLineH;
          const detBlockTop = detailTop + Math.max(0, (detailZoneH-detBlockH)/2);
          detailBlockBottom = detBlockTop + detBlockH;
          detailMarkup = detFit.lines.map((line,i)=>{
            const y = detBlockTop + (i+0.85)*detLineH;
            return `<text x="${cx}" y="${y}" text-anchor="middle" font-family="-apple-system,sans-serif" font-weight="600" font-size="${detFit.fontSize}" fill="${textColor}" opacity="0.9">${escapeXml(line)}</text>`;
          }).join('');
        }

        // Braille encodes the full message (headline + detail combined) as one
        // block below all the text, per §703.3.2. Real ADA dot spacing can
        // genuinely be wider than a compact sign for a long phrase — that's
        // physical reality, not a bug — so this scales down defensively rather
        // than letting it overflow, and the compliance panel flags when that happens.
        brailleSourceText = state.headline + (hasDetail ? ' ' + state.detail : '');
        const brailleCellsForWidth = textToBrailleCells(brailleSourceText.toLowerCase());
        const naturalBrailleW = brailleCellsForWidth.length
          ? brailleCellsForWidth.length*(brailleDotGap+brailleCellGap) - brailleCellGap : 0;
        if (naturalBrailleW > usableW*0.98 && naturalBrailleW > 0){
          const scale = (usableW*0.98) / naturalBrailleW;
          brailleDotR *= scale; brailleDotGap *= scale; brailleCellGap *= scale;
          brailleScaled = true;
        }
        const brailleBlockH = brailleDotGap*2 + brailleDotR*2;
        const brailleTop = detailBlockBottom + gapTextToBraille;
        const brailleY = brailleTop + brailleDotR;

        const pictoSizeLocal = Math.max(inchPx(0.6), Math.min(pictoZoneH, usableW*0.5));
        const pictoY = (pictoZoneTop+pictoZoneBottom)/2 - pictoSizeLocal/2;
        const pictoX = cx - pictoSizeLocal/2;
        const iconKey = TEMPLATES[state.template].icon;
        const pictoMarkup = iconImages[iconKey]
          ? `<image href="${iconImages[iconKey]}" x="${pictoX}" y="${pictoY}" width="${pictoSizeLocal}" height="${pictoSizeLocal}"/>`
          : `<g transform="translate(${pictoX}, ${pictoY}) scale(${pictoSizeLocal/36})">${iconPath(iconKey, textColor)}</g>`;

        headFit = headFitLocal;
        pictoSize = pictoSizeLocal;
        content = `
          ${pictoMarkup}
          ${headlineMarkup}
          ${detailMarkup}
          ${state.headline ? brailleMarkup(brailleSourceText, cx, brailleY, textColor, brailleDotR, brailleDotGap, brailleCellGap) : ''}
        `;
      }

      const svg = `
        <svg viewBox="0 0 ${vbW} ${vbH}" width="${vbW}" height="${vbH}" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Life safety sign preview">
          <defs>${defs}</defs>
          ${glow}
          ${shadowBehindMarkup}
          ${shapeMarkup(shapeName, px, py, plateW, plateH, `fill="${plateFill}" style="${plateShadow}" stroke="${plateStroke}" stroke-width="1"`, 6)}
          ${overlay}
          <g clip-path="url(#${clipId})">${onTopAccentMarkup}</g>
          ${standoffs}
          ${content}
        </svg>`;

      const stage = document.getElementById('ls-stage');
      let holder = stage.querySelector('.ss-svg-holder');
      if (!holder){
        holder = document.createElement('div');
        holder.className = 'ss-svg-holder';
        stage.insertBefore(holder, stage.querySelector('.ls-stage-caption'));
      }
      holder.innerHTML = svg;

      document.getElementById('ls-stage-dims').textContent = `${size.w}" × ${size.h}" — ${TEMPLATES[state.template].label}`;
      document.getElementById('ls-stage-mount').textContent = MOUNTINGS[state.mounting].label;

      const textColorEl = root.querySelector('#ls-textColor');
      if (textColorEl && document.activeElement !== textColorEl) textColorEl.value = state.textColor;
      const headlineEl = root.querySelector('#ls-headline');
      if (headlineEl && document.activeElement !== headlineEl) headlineEl.value = state.headline;
      const detailEl = root.querySelector('#ls-detail');
      if (detailEl && document.activeElement !== detailEl) detailEl.value = state.detail;
      const floorNumberEl = root.querySelector('#ls-floorNumber');
      if (floorNumberEl && document.activeElement !== floorNumberEl) floorNumberEl.value = state.floorNumber;
      const footerTextEl = root.querySelector('#ls-footerText');
      if (footerTextEl && document.activeElement !== footerTextEl) footerTextEl.value = state.footerText;
      const floorNumberField = root.querySelector('#ls-floorNumberField');
      if (floorNumberField) floorNumberField.style.display = (layoutKind==='stairId') ? '' : 'none';
      const footerTextField = root.querySelector('#ls-footerTextField');
      if (footerTextField) footerTextField.style.display = (layoutKind==='stairId') ? '' : 'none';

      buildChipRow(root.querySelector('#ls-templateRow'), TEMPLATES, 'template');
      buildChipRow(root.querySelector('#ls-shapeRow'), SHAPES, 'shape');
      buildChipRow(root.querySelector('#ls-typefaceRow'), TYPEFACES, 'typeface', (k)=>{
        return k!=='sans';
      });
      buildChipRow(root.querySelector('#ls-sizeRow'), SIZES, 'size', null, ()=>{ state.sizeManual = true; });
      buildChipRow(root.querySelector('#ls-mountingRow'), MOUNTINGS, 'mounting');
      buildChipRow(root.querySelector('#ls-accentRow'), ACCENTS, 'accent', (k,opt)=>{
        return !!(opt.incompatibleShapes && opt.incompatibleShapes.includes(shapeName));
      });
      const showAccentColor = ACCENTS[state.accent].needsColor;
      root.querySelector('#ls-accentColorField').style.display = showAccentColor ? '' : 'none';
      if (showAccentColor){
        buildChipRow(root.querySelector('#ls-accentColorRow'), ACCENT_COLORS, 'accentColor');
        root.querySelector('#ls-accentCustomColorField').style.display = (state.accentColor==='custom') ? '' : 'none';
      }

      // ---- ADA compliance is now standard on every sign, so nothing about
      // it is surfaced to the customer. These checks still run internally
      // (silently) rather than being deleted outright — character height and
      // pictogram field size are real physical failure modes (a sign can end
      // up genuinely out of spec depending on text length / size chosen), so
      // keeping the computation available for a future non-customer-facing
      // use (e.g. an internal QA flag before fabrication) seemed safer than
      // losing the check entirely. Matches Restroom Studio's treatment. ----
      const contrastPass = contrastRatio(state.textColor, state.plateColor) >= 4.5;
      const pictoInches = pictoSize / pxPerInch;
      const pictoMeetsField = pictoInches >= 5.99; // 6" minimum, tiny epsilon for float rounding
      const headCharInches = headFit.fontSize / pxPerInch;
      const headCharPass = headCharInches >= 0.625;
      const complianceEl = root.querySelector('#ls-complianceCheck');
      if (complianceEl) complianceEl.style.display = 'none';

      // ---- price from the matched real Shopify variant ----
      const variant = findVariant();
      const priceEl = document.getElementById('ls-priceValue');
      const unavailableEl = document.getElementById('ls-unavailable');
      const addBtn = document.getElementById('ls-addBtn');
      if (variant){
        priceEl.textContent = variant.price;
        if (!variant.available){
          unavailableEl.textContent = 'This combination is currently out of stock.';
          unavailableEl.style.display = '';
          addBtn.disabled = true;
        } else if (!state.headline.trim()){
          unavailableEl.textContent = 'Add headline text first.';
          unavailableEl.style.display = '';
          addBtn.disabled = true;
        } else {
          unavailableEl.style.display = 'none';
          addBtn.disabled = false;
        }
      } else {
        priceEl.textContent = '—';
        unavailableEl.textContent = "This exact combination isn't available yet — try a different size or mounting.";
        unavailableEl.style.display = '';
        addBtn.disabled = true;
      }
    }

    function bindTextInputs(){
      [['ls-plateColor','plateColor'],
       ['ls-accentCustomColor','accentCustomColor']].forEach(([id,key])=>{
        const el = root.querySelector('#'+id);
        if (!el) return;
        el.value = state[key];
        el.addEventListener('input', e=>{ state[key] = e.target.value; render(); });
      });
      const headlineEl = root.querySelector('#ls-headline');
      if (headlineEl){
        headlineEl.value = state.headline;
        headlineEl.addEventListener('input', e=>{
          state.headline = e.target.value;
          state.headlineManual = true;
          render();
        });
      }
      const detailEl = root.querySelector('#ls-detail');
      if (detailEl){
        detailEl.value = state.detail;
        detailEl.addEventListener('input', e=>{
          state.detail = e.target.value;
          state.detailManual = true;
          render();
        });
      }
      const floorNumberEl = root.querySelector('#ls-floorNumber');
      if (floorNumberEl){
        floorNumberEl.value = state.floorNumber;
        floorNumberEl.addEventListener('input', e=>{
          state.floorNumber = e.target.value;
          state.floorNumberManual = true;
          render();
        });
      }
      const footerTextEl = root.querySelector('#ls-footerText');
      if (footerTextEl){
        footerTextEl.value = state.footerText;
        footerTextEl.addEventListener('input', e=>{
          state.footerText = e.target.value;
          state.footerTextManual = true;
          render();
        });
      }
      const textColorEl = root.querySelector('#ls-textColor');
      if (textColorEl){
        textColorEl.value = state.textColor;
        textColorEl.addEventListener('input', e=>{
          state.textColor = e.target.value;
          state.textColorManual = true;
          render();
        });
      }
    }

    function addToCart(){
      const variant = findVariant();
      if (!variant || !variant.available || !state.headline.trim()) return;
      const errorEl = document.getElementById('ls-error');
      const addBtn = document.getElementById('ls-addBtn');
      errorEl.style.display = 'none';
      addBtn.disabled = true;
      const originalLabel = addBtn.textContent;
      addBtn.textContent = 'Adding…';

      const properties = {
        'Template': TEMPLATES[state.template].label,
        'Headline': state.headline,
        'Shape': SHAPES[state.shape].label,
        'Typeface': TYPEFACES[state.typeface].label,
        'Shape Color': state.plateColor,
        'Text Color': state.textColor
      };
      if (state.detail.trim()) properties['Detail'] = state.detail;
      if (TEMPLATES[state.template].layout === 'stairId'){
        if (state.floorNumber.trim()) properties['Floor Number'] = state.floorNumber;
        if (state.footerText.trim()) properties['Footer Text'] = state.footerText;
      }
      if (state.accent!=='none'){
        properties['Accent Style'] = ACCENTS[state.accent].label;
        properties['Accent Color'] = state.accentColor==='custom' ? state.accentCustomColor : ACCENT_COLORS[state.accentColor].label;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1, properties: properties }] })
      })
      .then(res => res.json().then(body => ({ ok: res.ok, body })))
      .then(({ ok, body })=>{
        addBtn.disabled = false;
        if (!ok){
          errorEl.textContent = (body && body.description) || 'Could not add this to your cart. Please try again.';
          errorEl.style.display = '';
          addBtn.textContent = originalLabel;
          return;
        }
        addBtn.textContent = 'Added ✓';
        addBtn.classList.add('ss-added');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: body } }));
        setTimeout(()=>{ addBtn.classList.remove('ss-added'); render(); }, 1800);
      })
      .catch(()=>{
        addBtn.disabled = false;
        addBtn.textContent = originalLabel;
        errorEl.textContent = 'Network error — please try again.';
        errorEl.style.display = '';
      });
    }

    root.querySelector('#ls-addBtn').addEventListener('click', addToCart);

    bindTextInputs();
    render();
    iconImagesReady.then(render);
  }
})();
